import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { DMSCustomQueryHistory } from "models";

export type CustomQueriesFilters = {
  dealer_location_id: number | null;
  page: number;
};

export type CustomQueryHistoryResponse = {
  items: DMSCustomQueryHistory[];
  nb_pages: number;
  nb_items: number;
};

const component = "DMSv3CustomQueries";

export const DMSv3CustomQueriesQueryKeys = {
  filters: localQueryKey<CustomQueriesFilters>({ component, data: "customQueriesFilters" }),
  selectedQuery: localQueryKey<DMSCustomQueryHistory | null>({ component, data: "selectedQuery" }),
  history: backendQueryKey<CustomQueryHistoryResponse>({ component, baseUrl: ENV.dmsAccessorBaseURL, endpoint: "/custom_queries/list" })
};
